/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";

class TableHeadColumn extends React.Component {
    static propTypes = {
        field: PropTypes.string,
        title: PropTypes.string,
        sort: PropTypes.string,
        onSort: PropTypes.func,
        className: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
        this.onClick = this.onClick.bind(this);
    }

    getSortDirection() {
        if (this.props.sort === this.props.field) {
            return (<i className="fa fa-sort-asc" aria-hidden="true"/>);
        } else if (this.props.sort === "-" + this.props.field) {
            return (<i className="fa fa-sort-desc" aria-hidden="true"/>);
        } else {
            return "";
        }
    }

    onClick(e) {
        e.preventDefault();
        if (!this.props.onSort) return;
        if (this.props.sort === this.props.field) {
            this.props.onSort("-" + this.props.field);
        } else if (this.props.sort === "-" + this.props.field) {
            this.props.onSort(null);
        } else {
            this.props.onSort(this.props.field);
        }
    }

    renderUnsortable() {
        return (
            <th className={this.props.className}>{this.props.title}</th>
        );
    }

    render() {
        if (!this.props.onSort) return this.renderUnsortable();
        return (
            <th className={this.props.className} onClick={this.onClick}><a href="#">{this.props.title}{" "}{this.getSortDirection()}</a></th>
        );
    }
}

export default TableHeadColumn;
